import { PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ImportIdCardsPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.idCards.imports.pageHeader.title')} />
}

ImportIdCardsPageHeader.displayName = 'ImportIdCardsPageHeader'
export default ImportIdCardsPageHeader
